//#region src/createModuleFederationConfig.ts
const createModuleFederationConfig = (options) => {
	return options;
};

//#endregion
export { createModuleFederationConfig };
//# sourceMappingURL=createModuleFederationConfig.js.map